import React, {useEffect,useRef} from 'react';
export default function ArcadeDialog({title,onClose,children}){
 const ref=useRef(null);
 useEffect(()=>{
  const prior=document.activeElement;
  const el=ref.current;
  const focusables=()=>[...el.querySelectorAll('button, a[href], input, [tabindex="0"]')];
  focusables()[0]?.focus();
  const key=e=>{
   if(e.key==='Escape'){e.stopPropagation();onClose();}
   if(e.key==='Tab'){
    const all=focusables(),first=all[0],last=all[all.length-1];
    if(e.shiftKey&&document.activeElement===first){e.preventDefault();last?.focus();}
    if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first?.focus();}
   }
  };
  el.addEventListener('keydown',key);
  return ()=>{el.removeEventListener('keydown',key);prior?.focus();};
 },[onClose]);
 return <div className="arcade-dialog" ref={ref} role="dialog" aria-modal="true" aria-label={title} onClick={e=>{if(e.target===e.currentTarget)onClose();}}>{children}</div>;
}
